import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../core/contexts/ThemeContext';
export function AboutApp() {
  const {
    theme,
    t
  } = useTheme();
  const isLightTheme = theme === 'light';
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 28
      }
    }
  };
  const capabilities = [{
    id: 'ux',
    key: 'about.capabilities.ux'
  }, {
    id: 'tech',
    key: 'about.capabilities.tech'
  }, {
    id: 'ai',
    key: 'about.capabilities.ai'
  }, {
    id: 'now',
    key: 'about.capabilities.now'
  }, {
    id: 'drive',
    key: 'about.capabilities.drive'
  }];
  return <div className="h-full overflow-y-auto p-5 md:p-16 pb-28" data-id="element-4" data-mp="3d1q7rqpbves3">
      <motion.div className="max-w-2xl mx-auto space-y-16 md:space-y-20" variants={containerVariants} initial="hidden" animate="visible" data-id="element-5" data-mp="3d31fg1lw96oh">
        <motion.section variants={itemVariants} className="space-y-5 md:space-y-6" data-id="element-6" data-mp="3494uur8do2b6">
          <h1 className={`text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-7" data-mp="2z7paz2hxs1ud">
            {t('about.heading')}
          </h1>
          <p className={`text-xl md:text-3xl leading-relaxed font-medium ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-8" data-mp="3mze6erq216fj">
            {t('about.intro')}
          </p>
        </motion.section>

        <motion.section variants={itemVariants} className="space-y-5 md:space-y-6" data-id="element-9" data-mp="2bkqwgaddn3z3">
          <h2 className="font-mono text-xs uppercase tracking-widest text-[#C8956C]" data-id="element-10" data-mp="26kuz2tz6qasi">
            {t('about.approach_title')}
          </h2>
          <p className={`text-lg md:text-xl leading-relaxed ${isLightTheme ? 'text-[#6B6B6B]' : 'text-[#9B9B9B]'}`} data-id="element-11" data-mp="28077uus8np3p">
            {t('about.approach')}
          </p>
        </motion.section>

        <motion.section variants={itemVariants} className="space-y-5 md:space-y-6" data-id="element-12" data-mp="1z3y639gsgeee">
          <h2 className="font-mono text-xs uppercase tracking-widest text-[#C8956C]" data-id="element-13" data-mp="1pc2961qfuubr">
            {t('about.capabilities_title')}
          </h2>
          <div className="space-y-4 md:space-y-5" data-id="element-14" data-mp="1u3ai6wnuwdoe">
            {capabilities.map(cap => {
            const text = t(cap.key);
            const [title, desc] = text.split(' — ');
            return <div key={cap.id} className={`p-5 md:p-6 rounded-xl border border-l-2 border-l-transparent hover:border-l-[#C8956C] transition-colors ${isLightTheme ? 'bg-white border-black/[0.06]' : 'bg-[#1A1A1A] border-white/[0.06]'}`} data-id="element-15" data-mp="1kd8wucmw19d6">
                  <div className={`font-mono text-sm font-medium mb-2 ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-16" data-mp="rqr8kl0o6q1g">
                    {title}
                  </div>
                  {desc && <div className={`text-base md:text-lg ${isLightTheme ? 'text-[#6B6B6B]' : 'text-[#9B9B9B]'}`} data-id="element-17" data-mp="wplqlkqtcaki">
                      {desc}
                    </div>}
                </div>;
          })}
          </div>
        </motion.section>
      </motion.div>
    </div>;
}